import { GalleryIcon, LegalIcon, PDFIcon, PlayIcon } from 'assets/icons';
import './styles.scss';
import { useState } from 'react';
import { ItemModal } from '../ItemModal';

const iconAdapter = {
  video: PlayIcon,
  'hinh-anh': GalleryIcon,
  'tai-lieu': PDFIcon,
  'phap-ly': LegalIcon,
};

export const ThuVienItemList = ({ items }) => {
  return (
    <div className="thu-vien-item-list">
      {items.map((item) => (
        <Item item={item} />
      ))}
    </div>
  );
};

const Item = ({ item }) => {
  const [open, setOpen] = useState(false);
  const Icon = iconAdapter[item.type];
  return (
    <>
      <div key={item.id} className="item" onClick={() => setOpen(true)}>
        {item.thumb && (
          <img src={item.thumb} alt={item.id} className="item-thumb" />
        )}
        {item.type === 'video' && (
          <div className="play-icon">
            <PlayIcon color="#fff" size={20} />
          </div>
        )}
        {item.title && (
          <div className="item-content">
            {Icon && <Icon color="#fff" size={16} />}
            <span>{item.title}</span>
          </div>
        )}
      </div>
      <ItemModal open={open} onClose={() => setOpen(false)} item={item} />
    </>
  );
};
